import { EyeOutlined, LockOutlined, MoreOutlined } from '@ant-design/icons';
import { Button, Card, Dropdown, Table, Tag } from 'antd';
import Column from 'antd/es/table/Column';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import { Company } from 'models/Company';
import { Country } from 'models/Country';

import { UseCompanyTableReturn } from '../hooks/useCompanyTable';

interface CompanyTableProps {
  table: UseCompanyTableReturn;
  countries: Country[];
  tableLoading: boolean;
}

function CompanyTable({ table, countries, tableLoading }: CompanyTableProps) {
  const { t } = useTranslation();
  const {
    filteredDataSource,
    tableParams,
    handleTableChange,
    getDropdownMenu,
    findCountryByCode,
  } = table;

  return (
    <Card style={{ marginTop: '12px' }}>
      <Table<Company>
        dataSource={filteredDataSource}
        bordered
        loading={tableLoading}
        size="small"
        scroll={{ x: 1300 }}
        pagination={tableParams.pagination}
        rowKey={(record) => record.id}
        onChange={handleTableChange}
      >
        <Column
          title={t('scenes.settings.companies.scene.table.columns.id')}
          dataIndex="id"
          key="id"
          width={60}
          align="center"
        />

        <Column
          title={t('scenes.settings.companies.scene.table.columns.name')}
          key="name"
          render={(row: Company) => <span>{row.name}</span>}
        />

        <Column
          width={160}
          title={t('scenes.settings.companies.scene.table.columns.country')}
          key="country"
          render={(row: Company) => (
            <span>
              {findCountryByCode(row.countryCode, countries)?.name ||
                row.countryCode}
            </span>
          )}
        />

        <Column
          width={120}
          align="center"
          title={t('scenes.settings.companies.scene.table.columns.visibility')}
          key="isPrivate"
          render={(row: Company) =>
            row.isPrivate ? (
              <Tag color="blue" icon={<LockOutlined />}>
                {t('scenes.settings.companies.scene.table.columns.is_private')}
              </Tag>
            ) : (
              <Tag color="default" icon={<EyeOutlined />}>
                {t('scenes.settings.companies.scene.table.columns.is_public')}
              </Tag>
            )
          }
        />

        <Column
          width={160}
          align="center"
          title={t('scenes.settings.companies.scene.table.columns.created_at')}
          dataIndex="createdAt"
          key="createdAt"
          render={(createdAt: Date) => (
            <span>{dayjs(createdAt).format('DD/MM/YYYY h:mm A')}</span>
          )}
        />

        <Column
          width={120}
          align="center"
          title=""
          key="actions"
          render={(row: Company) => (
            <Dropdown
              menu={{ items: getDropdownMenu(row) }}
              placement="bottomLeft"
              trigger={['click']}
            >
              <Button size="small">
                <MoreOutlined />
              </Button>
            </Dropdown>
          )}
        />
      </Table>
    </Card>
  );
}

export default CompanyTable;
